import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useDispatchToast } from "~/hooks/useDispatchToast/useDispatchToast"
import { useBulkCreatePaySupplements } from "./useBulkCreatePaySupplements"

import { PayrollChangeFormValues } from "../types"

interface Props {
  close: () => void
  onSuccess: () => void
}

export const useRecurringPayrollChange = ({ close, onSuccess }: Props) => {
  const { t } = useTranslation("Payroll")
  const dispatchToast = useDispatchToast()
  const [bulkCreatePaySupplements] = useBulkCreatePaySupplements({ handlePayloadErrors: true })

  return useCallback(
    ({ selectedEngagementId, amount, ...values }: PayrollChangeFormValues) => {
      const [startingYear, startingMonth] = values.startingMonth.split("-").map(Number)
      const [endingYear, endingMonth] = values.endingMonth.split("-").map(Number)

      return bulkCreatePaySupplements({
        variables: {
          ...values,
          startingMonth,
          startingYear,
          endingMonth,
          endingYear,
          engagementId: `Engagement:${selectedEngagementId}`,
          amount: Number(amount),
        },
      }).then(({ data }) => {
        if (!data?.bulkCreatePaySupplements.errors.length) {
          dispatchToast({ message: t("form.addSuccess"), toastProps: { variation: "success" } })
          onSuccess()
        } else {
          dispatchToast({
            message: data.bulkCreatePaySupplements.errors.join("\n"),
            toastProps: { variation: "error" },
          })
        }
        close()
      })
    },
    [bulkCreatePaySupplements, close, onSuccess, dispatchToast, t],
  )
}
